import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./cluster-selection-item-component.scss";
import PictureComponent from "/components/core/picture/picture-component";

export default class ClusterSelectionItemComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  onClick = () => {
    const { id, onClick } = this.props;
    onClick(id);
  };

  render() {
    const { title, imgSrc, color, isSelected, imgDimensions } = this.props;
    const componentStyle = { borderColor: color };

    return (
      <div
        className={classnames("cluster-selection-item-component", { selected: isSelected })}
        style={componentStyle}
        onClick={this.onClick}
      >
        <PictureComponent
          pictureClass="cluster-selection-item-image"
          src={imgSrc}
          alt={title}
          specificImageStyle={imgDimensions}
        />
        <div className="title">{title}</div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

ClusterSelectionItemComponent.defaultProps = {
  imgDimensions: { width: 30 }
};
